import { Injectable } from "@angular/core";
import { ModelNameKeyResolver } from "@ubisolutions/core";

/**
 * AssetBusiness's display name is client-customizable (ui.translations); other model
 * types use the generic, non-customizable models.<type>._name key.
 */
@Injectable()
export class CtModelNameKeyResolver implements ModelNameKeyResolver {
    resolve(typename: string): string {
        if (typename === "AssetBusiness") {
            return "assets.asset.singular";
        }
        return `models.${typename}._name`;
    }
}
